import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "patry-food-tip-title-bar" }
const _hoisted_2 = { class: "patry-food-tip-title-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "pantry-food-tip-title",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickTitle()))
  }, [
    _createVNode("div", {
      class: "patry-food-tip-title-text",
      style: {fontWeight: _ctx.styleText()}
    }, _toDisplayString(_ctx.getTitle()), 5),
    _withDirectives(_createVNode("div", _hoisted_1, null, 512), [
      [_vShow, _ctx.isActive()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, null, 512), [
      [_vShow, !_ctx.isActive()]
    ])
  ]))
}